// This file uses commonJS exports because it's referenced in our webpack build
"use strict";

const toVarName = require("./var-name.js");

const exportedNamePrefix = "__ns_account_components__exports__";

/**
 * Get the global variable name for a dynamically-imported file.
 * @param {string} name exported file name
 * @return name of the global variable where the exported values will be stored.
 */
function getExportedName(name) {
  return exportedNamePrefix + toVarName(name) + "__";
}

module.exports = {
  getExportedName,
};
